import { useState } from 'react';

export default function useContactForm() {
  const WORKER_URL = import.meta.env.VITE_PAWFRIENDS_API_ENDPOINT_CONTACT_FORM;

  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Handler za input promjene
  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  // Slanje na Cloudflare Worker
  const sendEmail = async recaptchaToken => {
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const res = await fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...form,
          recaptchaToken,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || 'Greška prilikom slanja emaila.');
      }

      setSuccess('Poruka je uspješno poslana!');
      setForm({
        name: '',
        email: '',
        subject: '',
        message: '',
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    form,
    loading,
    error,
    success,
    handleChange,
    sendEmail,
    setError,
    setSuccess,
  };
}
